


























import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import { ColorStyle } from "@/types";

@Component
class ColorSelect extends Vue {
  sheet = false;

  @State(state => state.app.settings) settings;

  @Mutation("app/SET_SETTINGS") setSettings;

  get color() {
    return this.settings.colorStyle;
  }

  set color(val) {
    this.setSettings({ ...this.settings, colorStyle: val });
  }

  get colorItems() {
    return [
      {
        value: ColorStyle.GREEN_UP_RED_DOWN,
        text: this.$t("setting.color-style.green_up_red_down"),
        active: this.color === ColorStyle.GREEN_UP_RED_DOWN
      },
      {
        value: ColorStyle.GREEN_DOWN_RED_UP,
        text: this.$t("setting.color-style.green_down_red_up"),
        active: this.color === ColorStyle.GREEN_DOWN_RED_UP
      }
    ];
  }

  get text() {
    const color = this.colorItems.find(c => c.value === this.color);
    return color && color.text;
  }

  handleSelect(color) {
    this.color = color.value;
    this.sheet = false;
  }
}
export default ColorSelect;
